import React from 'react';

export const FortifiedIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="39"
    height="34"
    viewBox="0 0 39 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 8.29664C2.69935 10.3585 9.04087 15.2918 19.0392 11.3894C20.3375 10.8827 21.5385 10.4023 22.6632 9.95701M30.7674 7.24134C33.1642 6.7437 35.4249 6.71011 38 7.33181"
      stroke="url(#paint0_linear)"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M1 25.3645C1.94539 26.6072 4.32752 28.8126 7.97674 29.7971M16.3488 29.6555C17.2136 29.4178 18.1106 29.1077 19.0392 28.7151C27.5761 25.1054 31.9083 22.726 38 24.3193"
      stroke="url(#paint1_linear)"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M1 17.2771C2.16832 18.7022 5.26343 21.432 10.5 21.7614M13.5581 21.7614C15.2379 21.5884 17.0675 21.1601 19.0392 20.3864C27.5761 17.0367 31.9083 14.8285 38 16.3071"
      stroke="url(#paint2_linear)"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.3733 1.72514C26.0236 0.352764 27.9764 0.352762 28.6266 1.72514L31.0741 6.89056L31.093 6.92328L31.0967 6.92965L31.1003 6.93609C31.4737 7.60758 31.686 8.38041 31.686 9.2004C31.686 11.7842 29.5857 13.8747 27 13.8747C24.4143 13.8747 22.314 11.7842 22.314 9.2004C22.314 8.38041 22.5263 7.60758 22.8997 6.93609L22.9032 6.92973L22.9069 6.92344L22.9259 6.89064L25.3733 1.72514ZM27.1807 2.41022C27.1085 2.25774 26.8915 2.25773 26.8192 2.41022L24.3575 7.6058L24.3433 7.63586L24.3266 7.66464L24.2947 7.71957C24.0522 8.15813 23.914 8.66204 23.914 9.2004C23.914 10.896 25.2933 12.2747 27 12.2747C28.7066 12.2747 30.086 10.896 30.086 9.2004C30.086 8.66206 29.9478 8.15818 29.7053 7.71964L29.6735 7.66481L29.6567 7.63595L29.6424 7.6058L27.1807 2.41022Z"
      fill="url(#paint3_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3592 20.6356C10.9968 19.2227 13.0031 19.2227 13.6406 20.6356L16.1799 26.2628L16.201 26.301L16.2045 26.3073L16.2078 26.3136C16.5861 27.0279 16.8 27.8473 16.8 28.7151C16.8 31.4346 14.685 33.7024 12 33.7024C9.31488 33.7024 7.19995 31.4346 7.19995 28.7151C7.19995 27.8473 7.41385 27.0279 7.79207 26.3136L7.79539 26.3074L7.79882 26.3012L7.81994 26.2629L10.3592 20.6356ZM12.1822 21.2937C12.1114 21.1367 11.8885 21.1367 11.8176 21.2937L9.26504 26.9505L9.25174 26.98L9.2361 27.0083L9.20294 27.0683C8.94702 27.5539 8.79995 28.1146 8.79995 28.7151C8.79995 30.6208 10.2667 32.1024 12 32.1024C13.7332 32.1024 15.2 30.6208 15.2 28.7151C15.2 28.1146 15.0529 27.554 14.797 27.0684L14.7639 27.0084L14.7482 26.98L14.7348 26.9505L12.1822 21.2937Z"
      fill="url(#paint4_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="9.47176"
        y1="11.0939"
        x2="16.9775"
        y2="-2.88799"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C49E19" />
        <stop offset="1" stopColor="#F5C518" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="9.47176"
        y1="28.0426"
        x2="16.9775"
        y2="14.0607"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C49E19" />
        <stop offset="1" stopColor="#F5C518" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="9.47176"
        y1="20.0244"
        x2="16.861"
        y2="6.1205"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C49E19" />
        <stop offset="1" stopColor="#F5C518" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="24.4599"
        y1="10.0093"
        x2="32.5857"
        y2="8.26892"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C49E19" />
        <stop offset="1" stopColor="#F5C518" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="9.39803"
        y1="29.559"
        x2="17.7533"
        y2="27.849"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C49E19" />
        <stop offset="1" stopColor="#F5C518" />
      </linearGradient>
    </defs>
  </svg>
);
